import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { createElementObject, createPathComponent, extendContext, updateCircle } from '@react-leaflet/core';
import { Circle as LeafletCircle } from 'leaflet';
export var Circle = createPathComponent(function createCircle(_ref, ctx) {
  var center = _ref.center,
      _c = _ref.children,
      options = _objectWithoutPropertiesLoose(_ref, ["center", "children"]);

  var circle = new LeafletCircle(center, options);
  return createElementObject(circle, extendContext(ctx, {
    overlayContainer: circle
  }));
}, updateCircle);